import { cn } from '@/shared/lib/utils'
import { useV2SContext } from './V2SProvider'

type Props = {
    duration: number // in seconds
    heading?: string
    className?: string
}

export const CircularDurationDisplay = ({ duration, heading = 'Duration', className }: Props) => {
    const { addedAudios } = useV2SContext()

    const formatTime = (secs: number) => {
        const hours = Math.floor(secs / 3600)
        const minutes = Math.floor((secs % 3600) / 60)
        const seconds = Math.floor(secs % 60)

        const parts = []
        if (hours > 0) parts.push(`${hours}h`)
        if (minutes > 0 || hours > 0) parts.push(`${minutes}m`)
        parts.push(`${seconds}s`)

        return parts.join(' ')
    }
    console.log(addedAudios.length)
    return (
        <div className={cn('flex flex-col items-center gap-3', className)}>
            {/* Heading */}
            <h2 className="text-lg font-bold text-primary tracking-wide">{heading}</h2>

            {/* Circle */}
            <div className="max-w-xs w-full px-8">
                <div className="relative w-full aspect-square rounded-full bg-gradient-to-tr from-primary to-primary/70 shadow-lg flex items-center justify-center">
                    <span className="text-white text-2xl font-bold drop-shadow-sm">
                        {formatTime(duration)}
                    </span>
                </div>
            </div>
        </div>
    )
}
